import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import {
  getCachedCompanySettings,
  isCompanySettingsLoaded,
  prefetchCompanySettings,
} from '../utils/companySettingsCache';

const CompanySettingsContext = createContext({
  settings: null,
  loaded: false,
});

export function CompanySettingsProvider({ children }) {
  const [settings, setSettings] = useState(() =>
    isCompanySettingsLoaded() ? getCachedCompanySettings() : null
  );
  const [loaded, setLoaded] = useState(() => isCompanySettingsLoaded());

  const loadSettings = useCallback(async () => {
    if (!localStorage.getItem('token')) {
      return;
    }
    if (isCompanySettingsLoaded()) {
      setSettings(getCachedCompanySettings());
      setLoaded(true);
      return;
    }
    const data = await prefetchCompanySettings();
    setSettings(data);
    setLoaded(true);
  }, []);

  useEffect(() => {
    void loadSettings();

    const onUserLoggedIn = () => {
      void loadSettings();
    };
    window.addEventListener('userLoggedIn', onUserLoggedIn);
    return () => {
      window.removeEventListener('userLoggedIn', onUserLoggedIn);
    };
  }, [loadSettings]);

  const value = useMemo(() => ({ settings, loaded }), [settings, loaded]);

  return (
    <CompanySettingsContext.Provider value={value}>
      {children}
    </CompanySettingsContext.Provider>
  );
}

export function useCompanySettings() {
  return useContext(CompanySettingsContext);
}
